module.exports = __webpack_public_path__ + "static/media/logo-v2.03346907.svg";